__turbopack_context__.v({
  "breadcrumb": "Breadcrumb-module__ouUvZa__breadcrumb",
  "item": "Breadcrumb-module__ouUvZa__item",
  "itemText": "Breadcrumb-module__ouUvZa__itemText",
  "reversed": "Breadcrumb-module__ouUvZa__reversed",
});
